module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_Mobilyze_image_9.c8aeec86.png";